import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { StoreFacadeService } from '../store/store-facade.service';

export const authGuard = () => {
  const storeFacade = inject(StoreFacadeService);
  const router = inject(Router);

  return storeFacade.selectProfile().pipe(
    take(1),
    map(profile => {
      const isAuthorized = profile?.authorized || false;

      if (!isAuthorized) {
        router.navigate(['/login']);
        return false;
      }

      return true;
    })
  );
};